import { BrandOverlayEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomBrandOverlayCreate2VO,
  RoomBrandOverlayDeleteVO,
  RoomBrandOverlayUnUseVO,
  RoomBrandOverlayUseVO
} from "@youm-front/room/domain";

export const roomBrandOverlayCreate = createAction(
  "[Room] Room Brand Overlay Create",
  props<{ roomBrandOverlayCreateVO: RoomBrandOverlayCreate2VO }>()
);
export const roomBrandOverlayCreateSuccess = createAction(
  "[Room] Room Brand Overlay Create Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);
export const roomBrandOverlayCreateFailure = createAction(
  "[Room] Room Brand Overlay Create Failure",
  props<{ error: string }>()
);

export const roomBrandOverlayDelete = createAction(
  "[Room] Room Brand Overlay Delete",
  props<{ roomBrandOverlayDeleteVO: RoomBrandOverlayDeleteVO }>()
);
export const roomBrandOverlayDeleteSuccess = createAction(
  "[Room] Room Brand Overlay Delete Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);
export const roomBrandOverlayDeleteFailure = createAction(
  "[Room] Room Brand Overlay Delete Failure",
  props<{ error: string }>()
);

export const roomBrandOverlayUnUse = createAction(
  "[Room] Room Brand Overlay Un Use",
  props<{ roomBrandOverlayUnUseVO: RoomBrandOverlayUnUseVO }>()
);
export const roomBrandOverlayUnUseSuccess = createAction(
  "[Room] Room Brand Overlay Un Use Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);
export const roomBrandOverlayUnUseFailure = createAction(
  "[Room] Room Brand Overlay Un Use Failure",
  props<{ error: string }>()
);

export const roomBrandOverlayUse = createAction(
  "[Room] Room Brand Overlay Use",
  props<{ roomBrandOverlayUseVO: RoomBrandOverlayUseVO }>()
);
export const roomBrandOverlayUseSuccess = createAction(
  "[Room] Room Brand Overlay Use Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);
export const roomBrandOverlayUseFailure = createAction(
  "[Room] Room Brand Overlay Use Failure",
  props<{ error: string }>()
);
